import { useCallback } from "react"

import { useFormik } from "formik"

import { isVaildParadiseLLMPromptsCategory } from "src/data/paradise/paradiseLLMPrompts/logic/paradiseLLMPromptsLogic"
import { usePostParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { Routes } from "src/router/routes"
import { useRouter } from "src/router/useRouter"

type TParadiseLLMPromptForm = {
  name: string
  category: string
  description: string
  prompt: string
}

const initialValues: TParadiseLLMPromptForm = {
  name: "",
  category: "",
  description: "",
  prompt: "",
}

export function useParadiseCreateLLMPromptForm() {
  const { navigate } = useRouter()

  const form = useFormik<TParadiseLLMPromptForm>({
    initialValues,
    onSubmit: createLLMPrompt,
  })

  const postParadiseLLMPrompt = usePostParadiseLLMPrompt()

  const setValues = useCallback(
    (update: Partial<TParadiseLLMPromptForm>) => {
      form.setValues((prev) => ({ ...prev, ...update }))
    },
    [form]
  )

  function createLLMPrompt(values: TParadiseLLMPromptForm) {
    if (!isVaildParadiseLLMPromptsCategory(values.category)) {
      return
    }

    postParadiseLLMPrompt.mutate(
      {
        body: {
          name: values.name,
          category: values.category,
          description: values.description,
          prompt: values.prompt,
        },
        path: {},
      },
      {
        onSuccess: (data) => {
          navigate(Routes.ParadiseLLMPrompt.location(data.id))
        },
      }
    )
  }

  return {
    form: {
      ...form,
      setValues,
    },
    isCreatingLLMPrompt: postParadiseLLMPrompt.isPending,
    createLLMPromptError: postParadiseLLMPrompt.error,
  }
}
